import ConversationListPage from '@pages/team/[teamId]/workspace/conversations';
import ConversationPage from '@pages/team/[teamId]/workspace/conversations/[conversationId]';

export const conversationRoutes = {
  path: 'conversations',
  children: [
    { path: '', element: <ConversationListPage /> },
    { path: ':conversationId', element: <ConversationPage /> },
  ],
};
